import { useMutation } from "@tanstack/react-query";

import { getLogoutRedirectUri } from "@/modules/authentication/actions/get-logout-redirect-uri";
import { signIn } from "next-auth/react";
import { CredentialsSignInDto } from "@/modules/authentication/schemas/credentials-sign-in-schema";
import { z } from "zod";
import { useCurrentLocale, useI18n } from "@/locales/client";
import { toast } from "@/components/ui/use-toast";

export const devUserRole = z.enum([
    "manager",
    "reseller",
    "agent",
    "customer",
    "publisher",
]);
export type DevUserRole = z.infer<typeof devUserRole>;

export const useLogoutRedirectUriMutation = ({
    onSuccess,
}: {
    onSuccess?: (res: { redirect: string }) => void;
} = {}) => {
    return useMutation({
        mutationFn: async (idToken: string | undefined) => {
            return await getLogoutRedirectUri(idToken);
        },
        onSuccess: (res) => {
            onSuccess?.(res);
        },
    });
};

export const useCredentialsLogin = () => {
    const t = useI18n();
    const locale = useCurrentLocale();

    return useMutation({
        mutationFn: async ({
            provider,
            credentials,
        }: {
            provider: string;
            credentials: CredentialsSignInDto;
        }) => {
            return await signIn(
                provider,
                { redirectTo: `/${locale}/auth/carts` },
                credentials,
            );
        },
        onError: () =>
            toast({ variant: "destructive", description: t("GenericFailure") }),
    });
};
